<mat-card>
    <mat-card-header>
        <div class="g-just-flex flex-between w-100 flex-wrap gap-20">
            <div class="left">
                <mat-card-title class="">
                    Diagnoses for
                    <a (click)="patientOpenAndClose.openPatientDetailsStrip()" style="text-decoration: none; 
                    cursor: pointer; color: var(--mat-sys-primary);" routerLinkActive="router-link-active">
                        {{patientName | async}}
                    </a>
                </mat-card-title>
                <mat-card-subtitle>
                    Find, search and add current and past diagnoses for this patient
                </mat-card-subtitle>
            </div>
            <div class="right gap-10 g-just-flex">
                <!-- @if(canExportDiagnosis | async){
                <a mat-flat-button extended class="secondary-button small-button">
                    <mat-icon>file_download</mat-icon> Export
                </a>
                } -->
                @if(canAddDiagnosis | async){
                <a mat-flat-button class="" (click)="encounterService.addDiagnosisV2()">
                    <mat-icon>add</mat-icon>
                    Add Diagnoses
                </a>}


            </div>
        </div>
    </mat-card-header>

    <mat-card-content class="my-12">
        <mat-divider></mat-divider>
        @if((tableDataLevel2 | async)?.length == 0 ) {
        <div class="g-just-flex flex-column align-items-center py-40" style="text-align:center;">
            <app-empty-state [icon]="'HOSPITAL'" [title]="'No Diagnoses Found'"
                [subtitle]="'There are no diagnoses recorded for this patient.'"></app-empty-state>
        </div>
        }@else{
        <app-table-header [patientsTableFilterArray]="  patientObservationTableFilterArray"
            [patientsFiltersFormControlObject]=" patientObservationFiltersFormControlObject">

        </app-table-header>
        <table mat-table matSort [dataSource]="tableDataSource" class="mat-elevation-z8 demo-table">

            <!--name - coding.code.display-->
            <ng-container matColumnDef="code">
                <th mat-header-cell *matHeaderCellDef mat-sort-header="code" sortActionDescription="Sort by Name">
                    Name
                </th>
                <td mat-cell *matCellDef="let element">
                    <!--stacked with severity   -->
                    <div class="stacked-cell py-6">  
                        <!--primary line-->
                        <div class="primary-line" [title]="element.code?.display">
                            
                    {{
                    element.code | codeableConcept2 | titlecase | na

                    }}
                </div>
                        <!--secondary line-->
                        <div class="secondary-line">
                           @if(element.severity){
                    <span [appEmphasis]="element.severity | codeableConcept2" [fontSize]="'13px'">
                        {{element.severity | codeableConcept2 | na | titlecase}}
                    </span>
                    } @else {
                    —
                    }
                        </div>
                    </div>    
                </td>
            </ng-container>

            <!--dateRecorded - recordedDateTime -->
            <ng-container matColumnDef="recordedDate">
                <th mat-header-cell *matHeaderCellDef mat-sort-header="recordedDate"
                    sortActionDescription="Sort by Date Recorded">
                    Date Recorded
                </th>
                <td mat-cell *matCellDef="let element">{{
                    element.recordedDate | date: 'mediumDate' | na}}</td>
            </ng-container>

            <!--category - category.coding.display -->
            <ng-container matColumnDef="category">
                <th mat-header-cell *matHeaderCellDef mat-sort-header="category"
                    sortActionDescription="Sort by Category">
                    Diagnosis Type
                </th>
                <td mat-cell *matCellDef="let element">
                    {{element.category | codeableConcept2 | na | titlecase}}

                </td>
            </ng-container>

            <!--verificationStatus - verificationStatus.coding[0].code   -->
            <ng-container matColumnDef="verificationStatus">
                <th mat-header-cell *matHeaderCellDef mat-sort-header="verificationStatus"
                    sortActionDescription="Sort by Verification Status">
                    Verification Status
                </th>
                <td mat-cell *matCellDef="let element">
                    @if(element.verificationStatus){
                    <div [appChips]="element.verificationStatus | codeableConcept2" [fontSize]="'14px'"></div>
                    }@else {
                    <span>N / A</span>
                    }
                </td>
            </ng-container>


            <!--clinicalStatus - clinicalStatus.coding[0].code -->
            <ng-container matColumnDef="clinicalStatus">
                <th mat-header-cell *matHeaderCellDef mat-sort-header="clinicalStatus"
                    sortActionDescription="Sort by Clinical Status">
                    Clinical Status
                </th>
                <td mat-cell *matCellDef="let element">
                    @if(element.clinicalStatus){
                    <div [appChips]="element.clinicalStatus | codeableConcept2" [fontSize]="'14px'"></div>
                    }@else {
                    <span>N / A</span>
                    }
                </td>
            </ng-container>
            <!--severity - severity.coding[0].display -->
            <ng-container matColumnDef="severity">
                <th mat-header-cell *matHeaderCellDef mat-sort-header="severity"
                    sortActionDescription="Sort by Severity">
                    Severity
                </th>
                <td mat-cell *matCellDef="let element">
                    @if(element.severity){
                    <span [appEmphasis]="element.severity | codeableConcept2" [fontSize]="'13px'">
                        {{element.severity | codeableConcept2 | na | titlecase}}
                    </span>
                    } @else {
                    —
                    }
                </td>
            </ng-container>
            <!--onsetDateTime - onsetDateTime -->
            <ng-container matColumnDef="onsetDateTime">
                <th mat-header-cell *matHeaderCellDef mat-sort-header="onsetDateTime"
                    sortActionDescription="Sort by Onset Date">
                    Onset Date
                </th>
                <td mat-cell *matCellDef="let element">
                    {{element.onsetDateTime | date: 'mediumDate'}}</td>
            </ng-container>
            <!--abatementDateTime - abatementDateTime -->
            <ng-container matColumnDef="abatementDateTime">
                <th mat-header-cell *matHeaderCellDef mat-sort-header="abatementDateTime"
                    sortActionDescription="Sort by Abatement Date">
                    Abatement Date
                </th>
                <td mat-cell *matCellDef="let element">{{element.abatementDateTime | date: 'medium'}}</td>
            </ng-container>
            <!--asserter - asserter.reference -->
            <ng-container matColumnDef="asserter">
                <th mat-header-cell *matHeaderCellDef mat-sort-header="asserter"
                    sortActionDescription="Sort by Asserter">
                    Asserter
                </th>
                <td mat-cell *matCellDef="let element">
                    <div class="top">
                        <!-- <span [appReferenceDisplay]="element.performer?.[0]?.reference"></span> -->
                        <span [appReferenceDisplay]="element.asserter?.reference" InstantfetchAndRepace="true"></span>
                    </div>
                </td>
            </ng-container>

            <!-- Add Actions Column -->
            <ng-container matColumnDef="action">
                <th mat-header-cell *matHeaderCellDef>Actions</th>
                <td mat-cell *matCellDef="let element">
                    <button mat-button color="primary" (click)="showDetails(element)">
                        View
                    </button>
                </td>
            </ng-container>

            <tr mat-header-row *matHeaderRowDef="patientConditionDisplayedColumns"></tr>
            <tr mat-row *matRowDef="let row; columns: patientConditionDisplayedColumns;"></tr>
        </table>}
    </mat-card-content>
</mat-card>